import { mapGetters } from "vuex"
export default {
  data() {
    return {
      labUsers: [
        "ADMIN",
        "LAB_ADMIN",
        "LAB_TECHNOLOGIST",
        "LAB_MANAGER",
        "BILLING_REPRESENTATIVE",
        "LAB_DATA_ASSISTANT",
        "LAB_SUPER_ADMIN",
        "LAB_DATA_ADMIN",
        "AR_LEAD",
        "AR_EXECUTIVE",
        "CP_LEAD",
        "CODING_LEAD",
        "CODING_EXECUTIVE",
        "POSTING_EXECUTIVE",
        "SR_FTE",
        "ACCOUNT_MANAGER",
      ],
      clientSalesUsers: [
        "ACCOUNT_MANAGER",
        "SALES_DIRECTOR",
        "HOSPITAL_MARKETING_MANAGER",
        "MARKETER",
        "REGIONAL_DIRECTOR",
        "SALES_SUPPORT_TEAM",
      ],
      permissions: {
        test_reports: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          resend_option: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          mark_for_physician: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
          ],
          delete: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
          edit_title: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
          update_download_status: [
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "ACCOUNT_MANAGER",
          ],
          view_download_status: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          finalize_report: ["LAB_TECHNOLOGIST", "LAB_DATA_ASSISTANT"],
          delete_report: ["LAB_SUPER_ADMIN"],
        },
        test_performed_by: {
          view: [
            "SALES_SUPPORT_TEAM",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_ADMIN",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        case_reports: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        exports: {
          view: [
            "ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
          ],
          sendout: [
            "ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        data_entry_template_generation: {
          view: [
            "LAB_DATA_ADMIN",
            "LAB_SUPER_ADMIN",
          ],
        },
        global_search: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "SALES_SUPPORT_TEAM",
          ],
          add: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
        },
        billing: {
          view: [
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
          ],
        },
        generate_barcode: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
          ],
          case_view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "SALES_DIRECTOR",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        generate_order_barcode: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
            "LAB_DATA_ASSISTANT",
          ],
        },
        hospital_reports: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        physician_reports: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },

        stats: {
          total_cases: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          pending_cases: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],

          total_orders: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          pending_orders: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],

          total_hospitals: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          total_physicians: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],

          total_users: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          pending_cases_list: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        result_files: {
          add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
          add_new: ["LAB_MANAGER", "LAB_TECHNOLOGIST", "LAB_SUPER_ADMIN"],
          user_account_view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "ACCOUNT_MANAGER",
          ],
        },
        user_accounts: {
          add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "ACCOUNT_MANAGER",
          ],
        },
        hospital_profile: {
          edit_profile: [
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "ACCOUNT_MANAGER",
          ],
        },
        hospitals: {
          view: [
            "SALES_SUPPORT_TEAM",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
            "BILLING_REPRESENTATIVE",
            "MARKETER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
          ],
        },
        physicians: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          add: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
            "LAB_TECHNOLOGIST",
            "ACCOUNT_MANAGER",
          ],
          delete: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "ACCOUNT_MANAGER",
          ],
          view_new: [
            "SALES_SUPPORT_TEAM",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
            "BILLING_REPRESENTATIVE",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        hospital_manager: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          add: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          edit: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          delete: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_ADMIN",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        orders: {
          row_actions: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "QC_MANAGER",
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
          ],
          delete: [
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "ACCOUNT_MANAGER",
          ],
          create: [
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
          ],
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          edit: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "LAB_DATA_ADMIN",
          ],
          create_accession: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          archive_orders: [
            "LAB_SUPER_ADMIN",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "SALES_SUPPORT_TEAM",
          ],
          pending_rejection: ["LAB_ADMIN", "LAB_MANAGER","LAB_SUPER_ADMIN","LAB_TECHNOLOGIST"],
          create_accession_new: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        emr_orders: {
          edit: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ADMIN",
          ],
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
          ],
          reject: ["LAB_ADMIN", "LAB_MANAGER", "LAB_SUPER_ADMIN"],
          view_new: [
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        validations: {
          cases: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            // "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          orders: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          emr_orders: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        lab_documents: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          add: ["ADMIN", "LAB_ADMIN", "LAB_SUPER_ADMIN"],
        },
        cases: {
          delete: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ADMIN",
          ],
          delete_billing_info: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          create: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          edit: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          save: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          update_status: ["LAB_TECHNOLOGIST", "LAB_MANAGER", "LAB_SUPER_ADMIN"],
          update_covid_status: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          update_billing_status: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          view: [
            "SALES_SUPPORT_TEAM",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "LAB_DATA_ASSISTANT",
            "MARKETER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          report_view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
          ],
          create_case: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "SALES_SUPPORT_TEAM",
          ],
          attachments: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
          labdaq_view: ["LAB_ADMIN", "LAB_MANAGER", "LAB_SUPER_ADMIN"],
          pharmacy_reports: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
          ],
          archive_cases: ["LAB_SUPER_ADMIN"],
          new_location: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "SALES_SUPPORT_TEAM",
          ],
          insurance_history: [
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          report_upload: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
          ],
          report_resend: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
          ],
          report_resend_new: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
          ],
          attachments_upload: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
          ],
          billing_attachments_upload: [
            "BILLING_REPRESENTATIVE",
          ],
          report_upload_new: [
            "ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
          ],
          create_case_new: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          create_new: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
          edit_new: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          report_upload_new_version: [
            "ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "QC_MANAGER",
          ],
          cases_filters_view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "MARKETER",
            "SALES_SUPPORT_TEAM",
          ],
          cases_filters_add: [
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "ACCOUNT_MANAGER",
          ],
          preliminary_report: [
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
          ],
          cases_filters_add_new: [
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "BILLING_REPRESENTATIVE",
            "ACCOUNT_MANAGER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "MARKETER",
            "SALES_SUPPORT_TEAM",
          ],
        },
        cases_filters: {
          view: [
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
        },
        case_count_report: {
          view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        pending_genetic_cases: {
          view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
          add: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          convert: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        billing_cases: {
          view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        patient_orders: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        patient_users: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },

        test_results: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          edit: [
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        bar_code: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        internal_notes: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        internal_documents: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        email_logs: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
          ],
        },
        user_logs: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "REGIONAL_DIRECTOR",
          ],
        },
        send_outs: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
          create: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
        },
        restore: {
          create: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ADMIN",
          ],
        },
        ICD_code: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "LAB_TECHNOLOGIST",
            "BILLING_REPRESENTATIVE",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
        archive_data: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        qc_charts_result_files: {
          view: ["LAB_MANAGER", "LAB_ADMIN", "LAB_SUPER_ADMIN"],
          add: ["LAB_MANAGER", "LAB_ADMIN", "LAB_SUPER_ADMIN"],
        },
        qc_charts: {
          view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ASSISTANT",
            "QC_MANAGER",
            "LAB_DATA_ADMIN",
          ],
          add: [
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ADMIN",
            "QC_MANAGER",
          ],
          upload: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ASSISTANT",
            "QC_MANAGER",
          ],
          upload_new: [
            "LAB_MANAGER",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "QC_MANAGER",
          ],
        },
        batching: {
          view: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        dashboard: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        cardiac_report_files: {
          view: [
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "LAB_TECHNOLOGIST",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
          ],
        },
        fax: {
          resend: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        signature: {
          add: ["HOSPITAL_PHYSICIAN"],
          view: ["HOSPITAL_PHYSICIAN"],
        },
        signature_on_file: {
          add: [
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "BILLING_REPRESENTATIVE",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "MARKETER",
            "REGIONAL_DIRECTOR",
            "LAB_TECHNOLOGIST",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_SUPER_ADMIN",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        test_profiles: {
          view: [
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
          ],
        },
        reports_tab: {
          view: [
            "SALES_SUPPORT_TEAM",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_MARKETING_MANAGER",
            "MARKETER",
            "SALES_DIRECTOR",
            "REGIONAL_DIRECTOR",
            "ACCOUNT_MANAGER",
          ],
        },
        notifications: {
          view: [
            "SALES_SUPPORT_TEAM",
            "ADMIN",
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_DATA_ASSISTANT",
            "HOSPITAL_ADMIN",
            "HOSPITAL_PHYSICIAN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "MARKETER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
            "BILLING_REPRESENTATIVE",
            "LAB_DATA_ADMIN",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
            "ACCOUNT_MANAGER",
          ],
        },
        global_permissions: {
          add: ["LAB_MANAGER", "LAB_SUPER_ADMIN", "LAB_TECHNOLOGIST"],
          edit: ["LAB_SUPER_ADMIN"],
        },
        network_payors: {
          view: ["LAB_SUPER_ADMIN", "BILLING_REPRESENTATIVE"],
        },
        add_tests: {
          view: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "HOSPITAL_ADMIN",
            "HOSPITAL_ACCOUNT_MANAGER",
            "HOSPITAL_PHYSICIAN",
            "MARKETER",
            "SALES_DIRECTOR",
            "HOSPITAL_MARKETING_MANAGER",
            "REGIONAL_DIRECTOR",
          ],
        },
        notify_rejection: {
          add: ["LAB_SUPER_ADMIN"],
        },
        emr_insurances: {
          view: [
            "LAB_SUPER_ADMIN",
            "LAB_DATA_ASSISTANT",
            "LAB_DATA_ADMIN",
            "BILLING_REPRESENTATIVE",
            "AR_LEAD",
            "AR_EXECUTIVE",
            "CP_LEAD",
            "CODING_LEAD",
            "CODING_EXECUTIVE",
            "POSTING_EXECUTIVE",
            "SR_FTE",
          ],
        },
      },
      allRolesList: [
        {
          name: "LAB_ADMIN",
          value: "LAB_ADMIN",
        },
        {
          name: "Lab Technologist",
          value: "LAB_TECHNOLOGIST",
        },
        {
          name: "Lab Manager",
          value: "LAB_MANAGER",
        },
        {
          name: "Physician",
          value: "HOSPITAL_PHYSICIAN",
        },
        {
          name: "Hospital Admin",
          value: "HOSPITAL_ADMIN",
        },
        {
          name: "Account Manager",
          value: "HOSPITAL_ACCOUNT_MANAGER",
        },
        {
          name: "Billing Representative",
          value: "BILLING_REPRESENTATIVE",
        },
        {
          name: "Lab Data Assistant",
          value: "LAB_DATA_ASSISTANT",
        },
        {
          name: "Marketer",
          value: "MARKETER",
        },
        {
          value: "HOSPITAL_MARKETING_MANAGER",
          name: "Hospital Marketing Manager",
        },
        {
          name: "Lab Super Admin",
          value: "LAB_SUPER_ADMIN",
        },
        {
          name: "Sales Director",
          value: "SALES_DIRECTOR",
        },
        {
          name: "Regional Director",
          value: "REGIONAL_DIRECTOR",
        },
        {
          name: "Lab Data Admin",
          value: "LAB_DATA_ADMIN",
        },

        {
          name: "AR-Lead",
          value: "AR_LEAD",
        },
        {
          name: "AR-Excutive",
          value: "AR_EXECUTIVE",
        },
        {
          name: "CP-Lead",
          value: "CP_LEAD",
        },
        {
          name: "Coding-Lead",
          value: "CODING_LEAD",
        },
        {
          name: "Coding-Excutive",
          value: "CODING_EXECUTIVE",
        },
        {
          name: "Posting-Excutive",
          value: "POSTING_EXECUTIVE",
        },
        {
          name: "Senior-FTE",
          value: "SR_FTE",
        },
        {
          name: "Account Manager",
          value: "ACCOUNT_MANAGER",
        },
        {
          name: "Sales Support Team",
          value: "SALES_SUPPORT_TEAM",
        },
      ],
      hospitalRolesList: [
        {
          name: "Physician",
          value: "HOSPITAL_PHYSICIAN",
        },
        {
          name: "Hospital Admin",
          value: "HOSPITAL_ADMIN",
        },
        {
          name: "Account Manager",
          value: "HOSPITAL_ACCOUNT_MANAGER",
        },
        {
          name: "Marketer",
          value: "MARKETER",
        },
        {
          value: "HOSPITAL_MARKETING_MANAGER",
          name: "Hospital Marketing Manager",
        },
        {
          name: "Sales Support Team",
          value: "SALES_SUPPORT_TEAM",
        },
      ],
    }
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    currentUserType() {
      const user = this.getAuthenticatedUser
      return user ? user.user_type : null
    },
    currentUserHospital() {
      const user = this.getAuthenticatedUser
      return user ? user.hospital : null
    },
    currentUserHospitalsData() {
      const user = this.getAuthenticatedUser
      return user ? user.hospitals : null
    },
    isLabUser() {
      return this.labUsers.indexOf(this.currentUserType) > -1
    },
    isClientSalesUser() {
      return this.clientSalesUsers.indexOf(this.currentUserType) > -1
    },
    isCurrentUserIsLabAdmin() {
      return this.currentUserType == "LAB_ADMIN"
    },
  },
  methods: {
    isLabUserAccount(user_type) {
      return this.labUsers.indexOf(user_type) > -1
    },
    hasPermission(type, action) {
      if (this.permissions[type] && this.permissions[type][action]) {
        let users = this.permissions[type][action]
        return users.indexOf(this.currentUserType) > -1
      }
      return true
    },
    showStatCase() {
      if (
        this.currentUserType == "QC_MANAGER" ||
        this.currentUserType === "BILLING_REPRESENTATIVE"
      ) {
        return true
      } else {
        return false
      }
    },
    isHospitalAdmin() {
      return (
        this.currentUserType === "HOSPITAL_ADMIN" ||
        this.currentUserType === "MARKETER" ||
        this.currentUserType === "HOSPITAL_MARKETING_MANAGER"
      )
    },
    getCurrentUserHospital() {
      return this.getAuthenticatedUser.hospital
    },
    allowedUserRolesList() {
      if (this.isHospitalAdmin()) {
        return this.hospitalRolesList
      } else {
        return this.allRolesList
      }
    },
  },
}
